module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/babel-preset-react-app/~/babel-runtime/regenerator/index.js
// module id = ./node_modules/babel-preset-react-app/node_modules/babel-runtime/regenerator/index.js
// module chunks = 0